export const SORT_ORDER = {
    ASC     : "asc",
    ASCEND  : "ascend",
    DESC    : "desc",
    SORT    : "sort",
};